export default {
	name: 'bill-query-redirect',
	mixins: [],
	extends: {},
	components: {},
	props: [],
	data() {
		return {
			
		};
	},
	computed: {
		
	},
	watch: {},
	created() {},
	mounted() {
        this.init();
    },
	updated() {},
	beforeDestroy() {},
	methods: {
        async init(){
            this.$router.push({ name: 'gt-warn', params: { msg: '無帳單資料可供查詢', title: '帳單查詢',
                returnName: 'bill-query-month' } });
		}
    },
};



// WEBPACK FOOTER //
// ./src/components/billQuery/billQueryRedirect.js